import { render, staticRenderFns } from "./HighlightPickerDropdown.vue?vue&type=template&id=f5f4b028&scoped=true"
import script from "./HighlightPickerDropdown.vue?vue&type=script&lang=js"
export * from "./HighlightPickerDropdown.vue?vue&type=script&lang=js"
import style0 from "./HighlightPickerDropdown.vue?vue&type=style&index=0&id=f5f4b028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4b028",
  null
  
)

export default component.exports